import { render, staticRenderFns } from "./HospitalTypesField.vue?vue&type=template&id=0c0418e8&scoped=true&"
import script from "./HospitalTypesField.vue?vue&type=script&lang=js&"
export * from "./HospitalTypesField.vue?vue&type=script&lang=js&"
import style0 from "./HospitalTypesField.vue?vue&type=style&index=0&id=0c0418e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0418e8",
  null
  
)

export default component.exports